// Single visual config for warranty visit pills on the calendar. Warranty has
// no sub-types, so one constant suffices (no Record). Rose family — distinct
// from both job chips and the task chips (slate/amber/sky/violet).

import { ShieldCheck, type LucideIcon } from 'lucide-react';

export interface WarrantyStyle {
  label: string;
  Icon: LucideIcon;
  /** Tailwind classes for the pill (bg + text + border). */
  chip: string;
  /** Solid dot color (month view), CSS color string. */
  dot: string;
}

export const WARRANTY_STYLE: WarrantyStyle = {
  label: 'Warranty',
  Icon: ShieldCheck,
  chip: 'bg-rose-100 text-rose-800 border-rose-300',
  dot: '#e11d48',
};
